/**
 * Groups a sorted array of numbers into sub-arrays of contiguous runs.
 *
 * Each group contains numbers that form an unbroken ascending sequence
 * (each element is exactly 1 greater than the previous).
 *
 * @example
 * ```ts
 * groupContiguous([0, 1, 2, 5, 6, 9]);
 * // → [[0, 1, 2], [5, 6], [9]]
 *
 * groupContiguous([3]);
 * // → [[3]]
 *
 * groupContiguous([]);
 * // → []
 * ```
 */
export function groupContiguous(sorted: number[]): number[][] {
  if (sorted.length === 0) {
    return [];
  }

  const groups: number[][] = [[sorted[0]]];

  for (let i = 1; i < sorted.length; i++) {
    const current = sorted[i];
    const lastGroup = groups[groups.length - 1];

    if (current === lastGroup[lastGroup.length - 1] + 1) {
      lastGroup.push(current);
    } else {
      groups.push([current]);
    }
  }

  return groups;
}
